'use client'

import {observer} from 'mobx-react'
import type {CollapseProps} from 'antd'
import React, {useState} from 'react'

import {useFormTesting} from '@/src/features/functional-testing'
import {FormTestingStep} from '@/src/features/functional-testing/store'
import {Collapse} from '@/src/shared/ui/collapse'

import * as UI from './form-steps-accordion.styled'

export type FormStepConfig = {
  step: number
  title: React.ReactNode
  summary?: React.ReactNode
  filled?: boolean
  content: React.ReactNode
}

type Step = (typeof FormTestingStep)[keyof typeof FormTestingStep]

export const FormStepsAccordion = observer(({steps}: {steps: FormStepConfig[]}) => {
  const store = useFormTesting()
  const [userCollapsedStep, setUserCollapsedStep] = useState<number | null>(null)

  const collapsedByUser = userCollapsedStep === store.step
  const activeKey = collapsedByUser ? [] : [String(store.step)]

  const items: CollapseProps['items'] = steps.map(({step, title, summary, content}) => ({
    key: String(step),
    collapsible: store.lastReached >= step ? undefined : 'disabled',
    label: (
      <UI.Header>
        <UI.Title>{title}</UI.Title>
        {summary && activeKey[0] !== String(step) && <UI.Summary>{summary}</UI.Summary>}
      </UI.Header>
    ),
    children: content,
  }))

  return (
    <Collapse
      activeKey={activeKey}
      onChange={keys => {
        const next = keys[0] ? Number(keys[0]) : null

        if (next === null) {
          // клик по активному заголовку: сворачиваем только заполненный шаг
          const current = steps.find(step => step.step === store.step)
          if (current?.filled) {
            setUserCollapsedStep(store.step)
          }
          return
        }

        setUserCollapsedStep(null)
        store.setStep(next as Step)
      }}
      items={items}
    />
  )
})
